import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-24 bg-[#1a4d3e] text-white" data-id="element-185">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#c9a227] mb-4" data-id="element-188">
            Historias Reales de Mujeres como Tú
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-189">
            Ellas también pensaron que era "imposible" bajar de peso después de
            los 40.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
          {/* Main Story - Lucía */}
          <motion.div whileHover={{
          y: -5
        }} className="col-span-1 lg:col-span-2 bg-white text-[#2d2d2d] p-8 rounded-2xl shadow-xl relative overflow-hidden" data-id="element-191">
            <Quote className="absolute top-4 right-4 text-[#c9a227]/20 w-24 h-24" data-id="element-192" />
            <div className="flex flex-col md:flex-row gap-6 relative z-10" data-id="element-193">
              <div className="flex-shrink-0" data-id="element-194">
                <div className="w-24 h-24 md:w-32 md:h-32 bg-gray-200 rounded-full overflow-hidden border-4 border-[#c9a227]" data-id="element-195">
                  {/* Placeholder for user avatar */}
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500 text-2xl font-serif" data-id="element-196">
                    L
                  </div>
                </div>
              </div>
              <div data-id="element-197">
                <div className="flex text-[#c9a227] mb-2" data-id="element-198">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-199" />)}
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-200">
                  "Bajé 2 tallas cuando dejé de hacer cardio"
                </h3>
                <p className="text-gray-600 italic mb-4" data-id="element-201">
                  "Estaba desesperada. Corría 5km diarios y la báscula no se
                  movía. Con el Metabo-Reset, entendí que estaba estresando mi
                  cuerpo. En la fase de Detox me sentí deshinchada por primera
                  vez en años. He recuperado mi cintura y mi energía."
                </p>
                <p className="font-bold text-[#1a4d3e]" data-id="element-202">— Lucía, 45 años</p>
                <p className="text-xs text-gray-500" data-id="element-203">
                  Madre de 2 hijos, Arquitecta
                </p>
              </div>
            </div>
          </motion.div>

          {/* Secondary Story */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-[#faf8f5] text-[#2d2d2d] p-8 rounded-2xl shadow-lg relative" data-id="element-204">
            <div className="flex text-[#c9a227] mb-4" data-id="element-205">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-206" />)}
            </div>
            <p className="text-gray-600 italic mb-6" data-id="element-207">
              "Pensé que mi metabolismo estaba 'roto' para siempre. Este
              protocolo me enseñó a comer para mis hormonas. La neblina mental
              desapareció en la primera semana."
            </p>
            <div className="flex items-center" data-id="element-208">
              <div className="w-10 h-10 bg-[#1a4d3e] rounded-full flex items-center justify-center text-white font-serif font-bold mr-3" data-id="element-209">
                M
              </div>
              <div data-id="element-210">
                <p className="font-bold text-[#1a4d3e]" data-id="element-211">María T.</p>
                <p className="text-xs text-gray-500" data-id="element-212">52 años</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}